var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { TeamService } from '../../../../services/workload/team.service';
import { ToastrService } from 'ngx-toastr';
var CreateTeamComponent = /** @class */ (function () {
    function CreateTeamComponent(teamService, toastr) {
        this.teamService = teamService;
        this.toastr = toastr;
        this.teamCreated = new EventEmitter();
        this.cancelCreation = new EventEmitter();
        this.updateTeamSubscription = new Subscription();
        this.viewModel = {
            createButtonText: 'CREATE',
            createButtonTitle: 'Create Team',
            team: {
                id: 0,
                name: '',
                teamMembers: []
            },
            teamNamePlaceholder: 'Team Name',
            cancelCreateAltText: 'Cancel team creation'
        };
    }
    CreateTeamComponent.prototype.ngOnDestroy = function () {
        this.updateTeamSubscription.unsubscribe();
    };
    CreateTeamComponent.prototype.cancelCreate = function () {
        this.cancelCreation.emit(true);
    };
    CreateTeamComponent.prototype.isFormValid = function () {
        var isValid = false;
        if (this.viewModel.team.name.trim() &&
            this.viewModel.team.name.length > 1)
            isValid = true;
        return isValid;
    };
    CreateTeamComponent.prototype.createTeam = function () {
        var _this = this;
        this.updateTeamSubscription = this.teamService.create(this.viewModel.team).subscribe(function (newTeam) {
            _this.teamCreated.emit(newTeam);
            _this.toastr.success(newTeam.name + " team has been created", 'Success!', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        }, function (error) {
            _this.toastr.error("Error creating " + _this.viewModel.team.name + " team", 'Error!', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        });
    };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], CreateTeamComponent.prototype, "teamCreated", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], CreateTeamComponent.prototype, "cancelCreation", void 0);
    CreateTeamComponent = __decorate([
        Component({
            selector: 'create-team',
            template: require('./create-team.component.html'),
            styles: [require('./create-team.component.scss')]
        }),
        __metadata("design:paramtypes", [TeamService, ToastrService])
    ], CreateTeamComponent);
    return CreateTeamComponent;
}());
export { CreateTeamComponent };
//# sourceMappingURL=data:application/json;base64,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